import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";

export type { DateClickArg };
export default interactionPlugin;
